export function toTablePagination(meta: { total: number; offset: number; limit: number }) {
    const current = meta.offset === 0 ? 1 : Math.round(meta.offset / meta.limit + 1);

    return {
        current,
        pageSize: meta.limit,
        total: meta.total,
    };
}
